import styled from "@emotion/styled";
import React from "react";
import ReactPlayer from "react-player";
import { match } from "ts-pattern";
import { TIMES_SVG } from "../../../utils/svgs";
import { AppIcon } from "../../Generic/AppIcon";

interface Props {
  type: "image" | "document" | "video";
  media: string;
  onClick: (media: string) => void;
}

function ChatRoomMediaWrapper(props: Props) {
  return (
    <ChatRoomMediaWrapper.Root>
      {match(props.type)
        .with("image", () => <ChatRoomMediaWrapper.Image src={props.media} />)
        .with("document", () => <embed src={props.media} width="72" height="72"></embed>)
        .with("video", () => (
          <ReactPlayer url={props.media} width="72px" height="72px" muted controls playing />
        ))
        .exhaustive()}
      <ChatRoomMediaWrapper.RemoveButton onClick={() => props.onClick(props.media)}>
        <AppIcon icon={TIMES_SVG} stroke="currentColor" size={8} />
      </ChatRoomMediaWrapper.RemoveButton>
    </ChatRoomMediaWrapper.Root>
  );
}

ChatRoomMediaWrapper.Root = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: fit-content;
`;

ChatRoomMediaWrapper.Image = styled.img`
  --size: 72px;
  width: var(--size);
  height: var(--size);
  object-fit: cover;
  border-radius: 16px;
`;

ChatRoomMediaWrapper.RemoveButton = styled.button`
  --size: 22px;
  background-color: white;
  color: #888;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 6px;
  right: 6px;
  width: var(--size);
  height: var(--size);
  flex-shrink: 0;

  .AppIcon {
    flex-shrink: 0;
    padding: 0;
  }
`;

export default ChatRoomMediaWrapper;
